<template>
    <div>
        <div class="toolbar d-flex flex-wrap justify-content-center">
            <ul class="toolbar__left game__child-tabs-component-tabs mr-auto">
                <li
                    v-for="item in children"
                    :key="item.code"
                    @click="activeGameChildTab(item.code)"
                    class="tabs-component-tab"
                    :class="{ 'is-active': item.code === activeTab }"
                >
                    <span class="tabs-component-tab-text">
                        {{ item.name.toString().replace(/^lô\strượt\s+/i, '') }}
                    </span>
                </li>
            </ul>
            <div
                class="toolbar__right"
            >
                <ul class="game__game-method-tabs-component-tabs">
                    <li
                        @click="activeGameMethodTab(chooseMethodId)"
                        class="tabs-component-tab "
                        :class="{
                            'is-active': chooseMethodId === playingMethod,
                        }"
                    >
                        <span
                            class="tabs-component-tab-text tabs-component-tab-text__choose"
                        >
                            Chọn số
                        </span>
                    </li>
                    <li
                        @click="activeGameMethodTab(inputMethodId)"
                        class="tabs-component-tab"
                        :class="{
                            'is-active': inputMethodId === playingMethod,
                        }"
                    >
                        <span
                            class="tabs-component-tab-text tabs-component-tab-text__input"
                        >
                            Nhập số
                        </span>
                    </li>
                </ul>
                <div class="game__rate d-none d-lg-inline-block">
                    <div class="game__rate-title">Tỉ lệ thắng</div>
                    <div class="game__rate-content font-weight-bold">
                        1 : {{ winRate }}
                    </div>
                </div>
            </div>
        </div>
        <tabs
            class="game__child"
            :options="{ useUrlFragment: false }"
            @changed="tabChanged"
            cache-lifetime="0"
            ref="gameChildTabs"
        >
            <tab
                class="game__child-tab"
                v-for="item in children"
                :key="item.code"
                :id="item.code"
                :name="item.name"
                v-bind="{ gameData: item }"
            >
                <div class="game__tab-wrapper">
                    <tabs
                        class="game__game-method"
                        cache-lifetime="0"
                        :options="{ useUrlFragment: false }"
                        :ref="`gameMethod${item.code}`"
                    >
                        <tab name="Chọn số" :id="chooseMethodId">
                            <List :game-info="item" :rate="winRate" />
                        </tab>
                        <tab name="Nhập số" :id="inputMethodId">
                            <DirectInput :game-info="item" :rate="winRate" />
                        </tab>
                    </tabs>
                </div>
            </tab>
        </tabs>
    </div>
</template>

<script>
import List from '@/components/Game/Games/Numbers/List/List';
import DirectInput from '@/components/Game/Games/Numbers/DirectInput/DirectInput';
import * as playingMethods from '@/utils/playingMethods';

const normalizeArray = arr => {
    return Array.isArray(arr) ? arr[0] : arr;
};

export default {
    components: { DirectInput, List },
    props: {
        children: Array,
        defaultTab: String,
        activeMethod: {
            type: String,
            default: playingMethods.CHOOSE_METHOD_ID,
            validator(value) {
                return [
                    playingMethods.CHOOSE_METHOD_ID,
                    playingMethods.INPUT_METHOD_ID,
                ].includes(value);
            },
        },
        rates: Array,
    },
    data() {
        return {
            activeTab: this.defaultTab,
            winRate: 0,
            chooseMethodId: playingMethods.CHOOSE_METHOD_ID,
            inputMethodId: playingMethods.INPUT_METHOD_ID,
        };
    },
    methods: {
        tabChanged(selectedTab) {
            const gameData = selectedTab.tab.$attrs.gameData;
            this.$emit('changeTab', gameData);
            this.activeTab = selectedTab.tab.id;
            this.winRate = this.getCategoryRate(
                selectedTab.tab.$attrs.gameData.id,
            );
            this.activeGameMethodTab(this.playingMethod);
        },
        activeGameChildTab(id) {
            const ref = normalizeArray(this.$refs.gameChildTabs);
            ref && ref.selectTab(`#${id}`);
        },
        activeGameMethodTab(method) {
            if (this.playingMethod !== method) {
                this.playingMethod = method;
            }
            const ref = normalizeArray(
                this.$refs[`gameMethod${this.activeTab}`],
            );
            ref && ref.selectTab(`#${method}`);
        },
        getCategoryRate(catId) {
            if (Array.isArray(this.rates)) {
                const rateInfo = this.rates.find(
                    r => +r.category_id === +catId,
                );
                if (rateInfo) {
                    return rateInfo.rate;
                }
            }
            return 0;
        },
    },
    watch: {
        defaultTab(v) {
            this.activeTab = v;
        },
    },
    model: {
        prop: 'activeMethod',
        event: 'changeActiveMethod',
    },
    computed: {
        playingMethod: {
            get() {
                return this.activeMethod;
            },
            set(method) {
                this.$emit('changeActiveMethod', method);
            },
        },
    },
    updated() {
        this.activeGameChildTab(this.activeTab);
    },
};
</script>

<style scoped lang="scss">
@import './GameChild';
</style>
